import { FormInstance } from 'antd/lib/form';
import { ProjectType, Undefinable } from 'providence-types';
import { ObjectComparatorService } from '@core/services';
import { momentizeObjectDates } from '@core/utils/methods';
import { SITE_AUDIT_MOMENTIZE_FIELDS } from '@models/constants';
import { SiteAuditInformation, SiteBrowse } from '@models/interfaces';
import { SiteInformationType } from '@models/types';
import { getLTEAdditionalInfo } from './get-lte-additional-info.constant';

export const onSiteInfoFormChange = (
  form: FormInstance,
  data: SiteInformationType,
  setIsSiteInfoCompare: (value: boolean) => void,
  projectType: ProjectType,
  unknownSwitchState: Undefinable<boolean>,
) => {
  const formValues = form.getFieldsValue() as Omit<SiteInformationType, 'site'>;

  const {
    site: { equipmentType, towerType },
    id,
    fileName,
    ...prevData
  } = data;

  setIsSiteInfoCompare(
    ObjectComparatorService.objectsCompare(
      {
        ...prevData,
        equipmentType,
        towerType,
      } as Omit<SiteAuditInformation, 'raycaps' | 'cables'> &
        Pick<SiteBrowse, 'equipmentType' | 'towerType'>,
      {
        ...momentizeObjectDates<Omit<SiteInformationType, 'site'>>(
          formValues,
          SITE_AUDIT_MOMENTIZE_FIELDS,
          true,
        ),
        ...getLTEAdditionalInfo(formValues, projectType, unknownSwitchState),
      },
      true,
    ),
  );
};
